var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 942,
    height: 720,
    viewBox: "0 0 942 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1907_10520",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-288.522 505.17L451.477 -240.819L662.672 -27.9153L-77.328 718.074L-288.522 505.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-288.522 505.17L451.477 -240.819L662.672 -27.9153L-77.328 718.074L-288.522 505.17Z",
    fill: "url(#paint0_linear_1907_10520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-287.837 505.861L452.163 -240.128L450.792 -241.51L-289.208 504.479L-287.837 505.861Z",
    fill: "url(#paint1_linear_1907_10520)",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_1907_10520)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1907_10520",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-306 685.277L729.892 -359L941.087 -146.096L-94.8055 898.18L-306 685.277Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-306 685.277L729.892 -359L941.087 -146.096L-94.8055 898.18L-306 685.277Z",
    fill: "url(#paint2_linear_1907_10520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-305.315 685.968L730.578 -358.309L729.207 -359.691L-306.685 684.586L-305.315 685.968Z",
    fill: "url(#paint3_linear_1907_10520)",
    fillOpacity: 0.2,
    mask: "url(#path-3-inside-2_1907_10520)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1907_10520",
    x1: -190.32,
    y1: 71.7434,
    x2: 69.9171,
    y2: 329.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1907_10520",
    x1: 81.4775,
    y1: 132.175,
    x2: 294.374,
    y2: 343.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E2F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1907_10520",
    x1: -102.207,
    y1: 145.404,
    x2: 158.031,
    y2: 403.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1907_10520",
    x1: 211.946,
    y1: 163.138,
    x2: 424.843,
    y2: 374.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E2F4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassEffect);
export default __webpack_public_path__ + "static/media/glass-effect.e2b74ff6eb1f6a67b8e760c628686fac.svg";
export { ForwardRef as ReactComponent };